import { render, staticRenderFns } from "./InstructionFilePreview.vue?vue&type=template&id=9c0d62f8"
import script from "./InstructionFilePreview.vue?vue&type=script&lang=ts"
export * from "./InstructionFilePreview.vue?vue&type=script&lang=ts"
import style0 from "./InstructionFilePreview.vue?vue&type=style&index=0&id=9c0d62f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports